// =============================================================================
// Lógica pura de pago del POS (sin React) — testeable en aislamiento.
// Regla del negocio: el vuelto sale SOLO del efectivo; los pagos no-efectivo
// (tarjeta/yappy/fiado) deben cuadrar exacto y NO generan vuelto. El servidor
// (pos_finalize_sale) revalida Σpagos − vuelto = total; esto es el espejo cliente.
// =============================================================================

export interface PaymentBreakdown {
  cash: number;
  nonCash: number;   // tarjeta + yappy + fiado
  total: number;
}

export interface PaymentResult {
  paid: number;          // total recibido (efectivo + no-efectivo)
  change: number;        // vuelto (solo del excedente de efectivo)
  enough: boolean;       // ¿cubre el total?
  nonCashOverpay: boolean; // ¿los no-efectivo exceden el total? (no permitido)
  valid: boolean;        // ¿se puede confirmar?
}

const EPS = 1e-6;

export function computePayment({ cash, nonCash, total }: PaymentBreakdown): PaymentResult {
  const paid = cash + nonCash;
  // Lo que el efectivo debe cubrir = total menos lo ya cubierto por no-efectivo.
  const cashNeeded = Math.max(0, total - nonCash);
  const change = Math.max(0, cash - cashNeeded);
  const enough = paid + EPS >= total;
  const nonCashOverpay = nonCash > total + EPS;
  return { paid, change, enough, nonCashOverpay, valid: enough && !nonCashOverpay };
}
